import Swal from 'sweetalert2';
import logger from './LocalServer/logger';

export const clearPromo = (cart, changePrice, products) => {
  logger(2, '[Promo]| clearPromo');
  // if (localStorage.getItem('codePromo')) localStorage.setItem('codePromo', null);
  if (localStorage.getItem('oneTime')) localStorage.setItem('oneTime', null);

  for (let i = 0; i < cart.length; i++) {
    const index = products.findIndex((e) => cart[i]._id === e._id);
    if (index > -1) {
      changePrice(
        { id: cart[i].id },
        products[index].discount ? products[index].discount : 0,
        products[index].discountedPrice ?? products[index].price,
        products[index].buyX ? products[index].buyX : 0,
        products[index].percentage,
        products[index].promo
      );
    }
  }
};

export const submitPromo = async (promoData, code, cart, changePrice, request) => {
  console.log('cart', cart);
  logger(2, '[Promo]| Code Entered: ' + code);
  return new Promise(async (resolve, reject) => {
    let result = null;
    for (let i = 0; i < promoData.length && !result; i++) {
      const e = promoData[i];
      if (e.code === code || e.oneTimeCode.includes(code)) {
        logger(2, '[Promo]| Code Is Found In Database: ' + code);
        if (e.promoType === 'generalWithCode') {
          if (e.cateOrProd === 'All Products') {
            resolve(1);
            logger(2, 'General with code applied');
            cart.forEach((item) => {
              let disPrice = e.percentage
                ? item.price - item.price * e.amount
                : item.price - e.amount;
              let discount = e.amount;
              if (disPrice < 0) {
                disPrice = 0;
                discount = item.price;
              }

              changePrice({ id: item.id }, discount, disPrice, 0, e.percentage, e._id);
              item.code = code;
              item.promoType = e.promoType;
            });
          }
          if (e.cateOrProd === 'cate') {
            if (e.category) {
              for (let i = 0; i < e.category.length; i++) {
                for (let j = 0; j < cart.length; j++) {
                  if (cart[j].category.includes(e.category[i]._id)) {
                    resolve(1);
                    logger(2, 'General with code applied');
                    let disPrice = e.percentage
                      ? cart[j].price - cart[j].price * e.amount
                      : cart[j].price - e.amount;
                    let discount = e.amount;

                    if (disPrice < 0) {
                      disPrice = 0;
                      discount = cart[j].price;
                    }
                    changePrice({ id: cart[j].id }, discount, disPrice, 0, e.percentage, e._id);
                    cart[j].code = code;
                    cart[j].promoType = e.promoType;
                  }
                }
              }
            }
          } else if (e.cateOrProd === 'prod') {
            if (e.product) {
              console.log('e.product', e.product);
              for (let i = 0; i < e.product.length; i++) {
                for (let j = 0; j < cart.length; j++) {
                  if (e.product[i]._id == cart[j].id) {
                    resolve(1);
                    logger(2, 'General with code applied');
                    let disPrice = e.percentage
                      ? cart[j].price - cart[j].price * e.amount
                      : cart[j].price - e.amount;
                    let discount = e.amount;
                    if (disPrice < 0) {
                      disPrice = 0;
                      discount = cart[j].price;
                    }
                    changePrice({ id: cart[j].id }, discount, disPrice, 0, e.percentage, e._id);
                    cart[j].code = code;
                    cart[j].promoType = e.promoType;
                  }
                }
              }
            }
          }
          result = 1;
        }

        if (e.promoType === 'oneTime' || e.promoType === 'nextPurchase') {
          if (cart.length === 1 && cart[0].quantity === 1) {
            logger(2, '[Promo]| One Time Promo Found, authenticating code: ' + code);
            result = 1;
            //send request to database check
            console.log('4444');
            await request({
              method: 'post',
              url: '/promos/authCode',
              data: {
                promo: e._id,
                input: code,
              },
              timeout: 5000,
            })
              .then((res) => {
                let find = false;
                localStorage.setItem('oneTime', JSON.stringify(e));
                if (e.cateOrProd === 'All Products') {
                  // console.log('5555');

                  const firstProd = cart[0];
                  logger(2, 'One time code applied');
                  firstProd.oneTime = code;
                  firstProd.code = code;
                  firstProd.promoType = e.promoType;
                  let disPrice = e.percentage
                    ? firstProd.price - firstProd.price * e.amount
                    : firstProd.price - e.amount;

                  let discount = e.amount;
                  if (disPrice < 0) {
                    disPrice = 0;
                    discount = firstProd.price;
                  }
                  changePrice({ id: firstProd.id }, discount, disPrice, 0, e.percentage, e._id);
                  resolve(1);
                }
                if (e.cateOrProd === 'cate') {
                  if (e.category) {
                    for (let j = 0; j < cart.length && !find; j++) {
                      for (let i = 0; i < e.category.length && !find; i++) {
                        if (cart[j].category.includes(e.category[i]._id)) {
                          logger(2, 'One time code applied');
                          let disPrice = e.percentage
                            ? cart[j].price - cart[j].price * e.amount
                            : cart[j].price - e.amount;
                          let discount = e.amount;
                          if (disPrice < 0) {
                            disPrice = 0;
                            discount = cart[j].price;
                          }
                          changePrice(
                            { id: cart[j].id },
                            discount,
                            disPrice,
                            0,
                            e.percentage,
                            e._id
                          );
                          cart[j].oneTime = code;
                          cart[j].code = code;
                          cart[j].promoType = e.promoType;
                          resolve(1);
                          find = true;
                        }
                      }
                    }
                  }
                } else if (e.cateOrProd === 'prod') {
                  if (e.product) {
                    for (let j = 0; j < cart.length && !find; j++) {
                      for (let i = 0; i < e.product.length && !find; i++) {
                        if (e.product[i]._id == cart[j].id) {
                          logger(2, 'One time code applied');
                          let disPrice = e.percentage
                            ? cart[j].price - cart[j].price * e.amount
                            : cart[j].price - e.amount;
                          let discount = e.amount;
                          if (disPrice < 0) {
                            disPrice = 0;
                            discount = cart[j].price;
                          }
                          changePrice(
                            { id: cart[j].id },
                            discount,
                            disPrice,
                            0,
                            e.percentage,
                            e._id
                          );
                          cart[j].oneTime = code;
                          cart[j].code = code;
                          cart[j].promoType = e.promoType;
                          resolve(1);
                          find = true;
                        }
                      }
                    }
                  }
                }
              })
              .catch((E) => {
                resolve(0);
                logger(2, '[Promo]| One Time Promo Auth Failed: ' + JSON.stringify(E));
                console.log('error during enter one time', E);
              });
          } else {
            logger(
              2,
              '[Promo]| One Time Promo Cant not be applied because there is more than one item in cart'
            );
            Swal.fire({
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              text: 'Please keep only 1 item in cart to apply this promo',
              icon: 'error',
            });
            resolve(2);
          }
        }
      }
    }
    if (!result) logger(2, '[Promo]| Code Not Found/Invalid: ' + code);
    resolve(0);
  });
};
